
import Dialog from '@material-ui/core/Dialog'

export default Dialog